<template>
  <div id="hull-list" class="aisea-text-12-400-dark-gray">
    <div>
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="table-area">
            <div class="header row">
              <div
                class="cell"
                :class="generateClassses(column)"
                v-for="column in columns"
                :key="column.key"
              >
                {{ column.displayName }}
              </div>
            </div>

            <div
              class="content-row row"
              :class="{
                highlighted: highlightCondition(rowData),
                'one-line': !allowCellLineBreak,
              }"
              v-for="(rowData, index) in data"
              :key="rowData.id"
              v-on:mouseover="hoveredRowIndex = index"
              v-on:mouseleave="hoveredRowIndex = null"
            >
              <span class="main-columns">
                <template v-for="column in columns">
                  <div
                    v-if="column.inputType == 'status'"
                    class="cell"
                    :class="generateClassses(column)"
                    :key="column.key + 'status'"
                  >
                    <status-chip
                      :label="rowData[column.key].label"
                      :color="rowData[column.key].color"
                    >
                    </status-chip>
                  </div>

                  <div
                    v-else-if="column.inputType == 'linkString'"
                    class="cell"
                    :class="generateClassses(column)"
                    :key="column.key + 'linkString'"
                  >
                    <p class="link-string" @click="clickLinkString(rowData.id)">
                      {{ rowData[column.key] }}
                    </p>
                  </div>
                  <div
                    v-else-if="column.inputType == 'string'"
                    class="cell"
                    :class="generateClassses(column)"
                    :key="column.key + 'string'"
                  >
                    <p>
                      {{ rowData[column.key] }}
                    </p>
                  </div>
                </template>
              </span>
              <transition name="fade">
                <div class="row-control" v-if="isHoveredRow(index)">
                  <feather-icon
                    icon="Edit2Icon"
                    class="control-icon-button"
                    @click="onClickEdit(rowData.id)"
                  />
                  <feather-icon
                    icon="Trash2Icon"
                    class="control-icon-button"
                    @click="onClickDelete(rowData.id)"
                  />
                </div>
              </transition>
            </div>
            <div
              class="message-area"
              v-if="isSearchResultNoData || noDataRegistered"
            >
              <slot
                name="isSearchResultNoData"
                v-if="isSearchResultNoData"
              ></slot>
              <slot name="noDataRegistered" v-if="noDataRegistered"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusChip from "./StatusChip";

export default {
  name: "M.HullList",
  components: {
    StatusChip,
  },
  props: {
    data: { type: Array },
    columns: { type: Array },
    pagination: { type: Boolean, default: false },
    totalPages: { type: Number },
    totalItems: { type: Number },
    currentPage: { type: Number },
    displayItems: { type: Object },
    isSearchResultNoData: { type: Boolean, default: false },
    noDataRegistered: { type: Boolean, default: false },

    allowCellLineBreak: { type: Boolean, default: true },

    onClickLinkString: {
      type: Function,
      default: () => {},
    },
    onClickEdit: {
      type: Function,
    },
    onClickDelete: {
      type: Function,
    },
    isHoverMenuActive: { type: Boolean, default: true },

    highlightCondition: {
      type: Function,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      hoveredRowIndex: null,
    };
  },

  methods: {
    isHoveredRow(index) {
      if (this.isHoverMenuActive) {
        return index == this.hoveredRowIndex;
      } else {
        return false;
      }
    },

    clickLinkString(id) {
      this.onClickLinkString(id);
    },

    generateClassses(columnData) {
      let classObj = {};
      classObj[columnData.key] = true;
      if (Object.prototype.hasOwnProperty.call(columnData, "cellClass")) {
        classObj[columnData.cellClass] = true;
      }
      return classObj;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/hull-insurance.scss";
#hull-list {
  overflow-x: auto;
  .table-area {
    background: white;
    border-radius: 8px;
    overflow: hidden;
  }
  .row-control {
    width: 110px;
    position: absolute;
    right: 0;
    background: wheat;
    height: 100%;
    background: linear-gradient(to right, transparent 0%, #f3faff 20%);

    display: flex;
    justify-content: end;
    .control-icon-button {
      cursor: pointer;
      width: 20px;
      margin-left: 8px;
      margin-right: 8px;
    }
  }

  .header {
    font-weight: bold;
  }
  .row {
    min-height: 37px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $item-mono6;
    padding-left: 8px;
    padding-right: 8px;
  }
  .row:last-child {
    border-bottom: none;
  }
  .content-row {
    justify-content: space-between;
    transition: 0.3s;
    flex-wrap: wrap;
    position: relative;
    word-break: break-all;
    &:hover {
      background: #f3faff !important;
    }
    &.highlighted {
      background: #eb575725;
    }
  }
  .main-columns {
    display: flex;
    flex-grow: 1;
  }
  .cell {
    display: flex;
    margin-right: 8px;
    padding: 5px 10px;
    align-items: center;
    .link-string {
      color: $common-link-text-blue;
      cursor: pointer;
    }
    &.label {
      min-width: 170px;
      max-width: 170px;
    }
    &.step {
      flex-grow: 1;
      min-width: 200px;
    }
    &.update_date {
      min-width: 100px;
      max-width: 100px;
    }
    &.template_status {
      min-width: 100px;
      max-width: 100px;
    }

    &.claim_type_name {
      min-width: 220px;
      max-width: 220px;
    }
    &.required_info_name {
      min-width: 180px;
      max-width: 180px;
    }
    &.info_type {
      min-width: 100px;
      max-width: 100px;
    }
    &.description_owner {
      flex-grow: 1;
      min-width: 150px;
    }
    &.reference_no {
      min-width: 80px;
      max-width: 80px;
    }
    &.title {
      flex-grow: 1;
      min-width: 160px;
    }
    &.vessel_name {
      min-width: 160px;
      max-width: 160px;
    }
    &.accident_date {
      min-width: 85px;
      max-width: 85px;
    }
    &.accident_place {
      min-width: 110px;
      max-width: 110px;
    }
    &.company_name {
      min-width: 160px;
      max-width: 160px;
    }
    &.vessel_contact_name {
      min-width: 130px;
      max-width: 130px;
    }
    &.insurance_contact_name {
      min-width: 130px;
      max-width: 130px;
    }
    &.status {
      min-width: 85px;
      max-width: 85px;
    }
  }
  .one-line {
    p {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .message-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
